var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.60004 7.99999C2.60004 6.85999 3.52671 5.93332 4.66671 5.93332H7.33337V4.66666H4.66671C2.82671 4.66666 1.33337 6.15999 1.33337 7.99999C1.33337 9.83999 2.82671 11.3333 4.66671 11.3333H7.33337V10.0667H4.66671C3.52671 10.0667 2.60004 9.13999 2.60004 7.99999ZM5.33337 8.66666H10.6667V7.33332H5.33337V8.66666ZM11.3334 4.66666H8.66671V5.93332H11.3334C12.4734 5.93332 13.4 6.85999 13.4 7.99999C13.4 9.13999 12.4734 10.0667 11.3334 10.0667H8.66671V11.3333H11.3334C13.1734 11.3333 14.6667 9.83999 14.6667 7.99999C14.6667 6.15999 13.1734 4.66666 11.3334 4.66666Z",
    fill: "#A8ADB2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.a26ec0c9794debc6631801af307c751a.svg";
export { ForwardRef as ReactComponent };